import store from "@/store";
let propertiesDev = [];
let routers = [
    {
        path: '*',
        beforeEnter(to, from, next) {

            window.location = "https://vtr.com/miregistro/404error.jsp"
        }
    }, {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home.vue')
    },
    {
        path: '/curtain',
        name: 'curtain',
        component: () => import('@/views/ViewCortina.vue')
    },
    {
        path: '/start/',
        name: 'start',
        component: () => import('@/views/Start.vue')
    },
    {
        path: '/start/:pid',
        name: 'start',
        component: () => import('@/views/Start.vue')
    },
    {
        path: '/start/:pid/:sessionid',
        name: 'start',
        component: () => import('@/views/Start.vue')
    },
    {
        path: '/start/:customerIdentificationNumber/:paymentType/:paymentChannel/:context/:notificationEmail/:muestraVencido/:metadata?',
        name: 'start',
        component: () => import('@/views/Start.vue')
    },
    {
        path: '/initial',
        name: 'initial',
        component: () => import('@/views/Initial.vue')
    },
    {
        path: '/initial/:pid',
        name: 'initial',
        component: () => import('@/views/Initial.vue')
    },
    {
        path: '/billing',
        name: 'billing',
        component: () => import('@/views/Billing.vue')
    },
    {
        path: '/payment',
        name: 'payment',
        component: () => import('@/views/Payment.vue')
    },
    {
        path: '/invoice/:transaction',
        name: 'invoice',
        component: () => import('@/views/Invoice.vue')
    },
    {
        path: '/invoice/',
        name: 'invoice',
        component: () => import('@/views/Errorservice.vue')
    },
    {
        path: '/error/:transaction',
        name: 'error',
        component: () => import('@/views/Error.vue')
    },
    {
        path: '/errorservice',
        name: 'errorservice',
        component: () => import('@/views/Errorservice.vue')
    }];
    
if (store.getters.curtain.activa) {
    if (window.location.href.includes("initial")) {
        store.dispatch("resetBillingState");
        propertiesDev = routers;
    } else {
        propertiesDev = [
            {
                path: '*',
                name: 'viewcortina',
                component: () => import('@/views/ViewCortina.vue')
            }
        ]
    }
}
else {
    propertiesDev = routers;
}

export default propertiesDev;
